<template lang="pug">
  el-card.card-container(shadow="hover")
    .btn-cadastrar(
      v-if="hasActionButton || hasActionButtonAvocar || showButtonCadastraOS || tituloCard"
    )
      h1(:style="{'font-size': fontSizeTituloCard}") {{ tituloCard }}
      el-button(
        v-if="hasActionButton",
        @click="$emit('click')",
        :type="typeActionButton",
        :icon="iconActionButton",
        :size="sizeActionButton"
      )
        span.center {{ nameActionButton }}
      el-button(
        v-if="showButtonCadastraOS",
        @click="selected",
        :size="sizeActionButton",
        type="success",
        icon="el-icon-plus",
      )
        span.center Cadastrar &nbsp

    div
      app-relatorio-prazos(
        v-if="infoPrazos && possuiGestaoPrazo",
        :infoPrazos="infoPrazos"
      )
      el-button.margin-left-100.buttonAvocar(
        v-if="hasActionButtonAvocar",
        :disabled="disableButtonAvocar",
        @click="$emit('avocar')",
        type="success",
        plain,
        :size="sizeActionButton"
      )
        span.center Avocar Processo
      app-divider-refresh-button(
        v-if="hasHeader || hasRefreshButton",
        :label="headerLabel",
        :hasButton="hasRefreshButton",
        :content="tooltipRefreshButton",
        :showBorder="false",
        @click="updateListagem"
      )
        template(slot="info")
          div(v-if="hasFiltroRapido")
            el-tooltip(
              content='São considerados processos com pendência aqueles que tem uma notificação ou solicitação de informação aguardando resposta',
              placement='right'
            )
              i.el-icon-info.icon
    el-alert(
      title="Selecione apenas processos do mesmo tipo para analisar"
      type="warning"
      show-icon,
      :closable="false"
      v-if="showObsOficioMA"
    )
    el-alert(
      title="Selecione processos não onerosos para realizar validação coletiva"
      type="warning"
      show-icon,
      :closable="false"
      v-if="showValidacaoColetiva"
    )
    el-alert(
      title="Selecione apenas processos com a mesma situação para analisar"
      type="warning"
      show-icon,
      :closable="false"
      v-if="estado === 'ba' && filtro && filtro.caixa === 'ASSINATURAS'"
    )
    el-row
      .divider(v-if="showBorder")
    el-row(v-if="busca")
      el-input(
        v-model="search",
        size="medium",
        placeholder="Informe o nome do analista"
      )
        el-button(slot="append")
          i.el-icon-search.color-default
    div.row(v-if="hasFiltroRapido")
      div.row-label
        div.label-test(v-if="optionsSelect.length > 1")
          b {{optionsSelect[0].titulo}}:
        div.margin-left-10.label-test
          el-checkbox(
            v-for='pendencia in optionsSelect[0].pendencia',
            :key='pendencia.id'
            :value="pendencia.value"
            @change="handleCheckedFiltroRapido(pendencia, optionsSelect[0])"
          ) {{pendencia.label}}

      div.row-label.margin-left-20(v-if="optionsSelect.length >= 2 && optionsSelect[1]")
        div.label-test
          b {{optionsSelect[1].titulo}} :
        div.margin-left-10.label-test
          el-checkbox(
            v-for='pendencia in optionsSelect[1].pendencia',
            :key='pendencia.id'
            :value="pendencia.value"
            @change="handleCheckedFiltroRapido(pendencia, optionsSelect[1])"
          ) {{pendencia.label}}

      div.row-label.margin-left-20(v-if="optionsSelect.length === 3 && optionsSelect[2]")
        div.label-test
          b {{optionsSelect[2].titulo}} :
        div.margin-left-10.label-test
          el-checkbox(
            v-for='pendencia in optionsSelect[2].pendencia',
            :key='pendencia.id'
            :value="pendencia.value"
            @change="handleCheckedFiltroRapido(pendencia, optionsSelect[2])"
          ) {{pendencia.label}}

    el-table(
      :key="filtro && filtro.caixa"
      :data="paginate ? paginatedData[pagina] : jsonData.filter((data) => !search || data.nome && data.nome.toLowerCase().includes(search.toLowerCase()))",
      :default-sort="{ prop: 'id', order: 'descending' }",
      :class="{ 'hide-header-checkbox': isPa && this.isVariosTiposProcesso()}"
      @expand-change="rowClicked"
      @sort-change="sort",
      @selection-change="selectAll",
      @row-click="rowClick"
      :style="{cursor: hasRowClick ? 'pointer' : 'default'}"
      :row-key="getRowKeys",
      :expand-row-keys="expandRowKeys",
      ref="tableData"
    )
      template(slot="empty", v-if="!jsonData") Não há registros.
      template(slot="empty", v-else) {{ dadosNaoEncontrado }}

      //- Se for expansivel
      template(v-if="hasExpansivel")
        el-table-column(type="expand", width="50")
          template(slot-scope="scope")
            div(v-if="!subProcessos.source || subProcessos.source.length === 0")
              span Não há processos vinculados nessa OS
            el-card.card-container(
              shadow="hover",
              v-for="(processo, indexOrdem) in subProcessos.source",
              key="indexOrdem",
              v-else
            )
              .flex
                b {{ 'Numero processo: ' + processo.numeroProcesso }}
                el-tooltip#tooltip(
                  effect="dark",
                  content="Visualizar Processo",
                  placement="bottom"
                )
                  font-awesome-icon.botao-visualizar(
                    @click="goVisualizarProcesso(processo)",
                    icon="eye"
                  )
              .divider
              .margin-top
                p.font-14px.espacamento
                  b Interessado:
                  | &nbsp {{ processo.nomeRazaoSocialInteressado }}
                p.font-14px
                  b.14px CPF/CNPJ:
                  | &nbsp {{ processo.cpfCnpjInteressado }}
              .margin-top(v-for="membro in processo.processos")
                p.font-14px.espacamento
                  b {{ 'Análise ' + membro.funcoes + ':' }}
                  | &nbsp {{ membro.status }}
                p.font-14px
                  b Responsável:
                  | &nbsp {{ membro.responsavel }}
            div
              .pagination(v-if="subProcessos.pageSize > 0")
                el-pagination(
                  layout="prev, pager, next",
                  small
                  :total="subProcessos.pageSize",
                  :current-page="subProcessos.page + 1",
                  :page-size="10",
                  @current-change="alterarPaginaSubProcesso"
                )
      el-table-column(
        v-if="hasMultipleCheckbox"
        type="selection",
        width="55"
        :selectable="checkboxHabilitado"
      )

      //- Coluna dedicada para badge Cadastrante Externo (somente MA)
      el-table-column(
        label="",
        width="48",
        align="left",
        header-align="center",
        v-if="isMaranhao"
      )
        template(slot-scope="scope")
          el-tooltip(
            v-if="showContratanteExternoBadge(scope.row)",
            effect="dark",
            content="Cadastrante Externo",
            placement="right",
            :append-to-body="true"
          )
            span(class="el-icon-user-solid" style="color: red")

          el-tooltip(
            v-if="showInteressadoOuConjugeOutroProcessoReurbBadge(scope.row)",
            effect="dark",
            content="Interessado e/ou cônjuge com outro processo REURB",
            placement="right",
            :append-to-body="true"
          )
            span(class="el-icon-warning" style="margin-left: 8px")

      template(v-for="(header, indexHeader) in jsonHeaders")

        el-table-column(
          :width="isMaranhao && !(caixa && caixasPermiteCheckbox) ? 1 : 40",
          v-if="jsonHeaders[indexHeader].marcado && jsonHeaders[indexHeader].marcado()"
        )
          template(slot-scope="scope")
            el-tooltip(
              placement="right",
              :disabled="usuario && !usuario.perfilSelecionado.setor.codigo !== 'CAF' || (!scope.row.disabled && !scope.row.retificacao && !scope.row.conversaAberta)",
              :content="scope.row.retificacao ? 'Processo em retificação' : scope.row.disabled ? 'Análise finalizada' : 'Conversa aberta'"
            )

            el-checkbox(
              v-if="!isMaranhao || caixasPermiteCheckbox"
              :value="scope.row.selecionado",
              :disabled="desabilita(scope.row)",
              @change="selecionaItem(scope.row)"
            )

        //- Coluna para icones
        el-table-column(
          align="left",
          width="80",
          v-if="jsonHeaders[indexHeader].type === 'icone-credenciado'"
        )
          template(slot-scope="scope")
            div
              el-tooltip(
                class="el-icon-user-solid",
                :style="isPa ? { color: getColorIconCredenciado(scope.row) } : {}"
                effect="dark",
                :content="getTextoCredenciado(scope.row)",
                placement="left",
                )
                  span(class="el-icon-user-solid")
                  el-col(:span='10')
        el-table-column(
          align="left",
          width="80",
          v-if="jsonHeaders[indexHeader].type === 'icone' && !(isMaranhao && hasMultipleCheckbox && isCaixaTituloCertidao)"
        )
          template(slot-scope="scope")
            el-row(:gutter="30")
              el-col(:span="10")
                div(v-if="scope.row.statusFilaAnaliseAutomatizada === 'ERRO' && (scope.row.tipo === 'REURB-S' || scope.row.tipoCodigo === 'NAO_ONEROSO' || scope.row.tipoCodigo === 'ONEROSO') && (scope.row.setor.includes('GCG') || scope.row.setor.includes('CGIR'))")
                  el-tooltip(
                    effect="dark",
                    :content="$messages.ERRO_ANALISE_AUTOMATIZADA",
                    placement="left",
                    )
                      span(class="el-icon-warning color-laranja")
                div(v-if="!isCaixaSolicitarInformacao && scope.row.tipoCodigo === 'REURB_INDIVIDUAL' && scope.row.setor.includes('COMISSAO_ILHA') && scope.row.codigoStatus.includes('AGUARDANDO_PLANTA_MEMORIAL')")
                  el-tooltip(
                    v-if="statusResultadoLogArqGIS(scope.row.resultadoLogProcessamentoArcGisStatus)"
                    effect="dark",
                    :content="scope.row.resultadoLogProcessamentoArcGisMensagem",
                    placement="left",
                    )
                      span(class="el-icon-warning color-laranja")
                  el-tooltip(
                    v-if="statusResultadoLogArqGISNaoFinalizado(scope.row.resultadoLogProcessamentoArcGisStatus)"
                    effect="dark",
                    :content="scope.row.resultadoLogProcessamentoArcGisMensagem",
                    placement="left",
                    )
                      span(class="el-icon-time color-laranja")
                div(v-if="scope.row.codigoStatus === 'AGUARDANDO_CONVERSAO_UTM_GEOGRAFICA'")
                  el-tooltip(
                    effect="dark",
                    content="Processo aguardando conversão de UTM para Geográfica",
                    placement="left",
                    )
                      span(class="el-icon-warning")
                div(v-if="filtro && filtro.caixa === 'DAE' && scope.row.alertaPreEmissaoAutomaticaDae")
                  el-tooltip(
                    effect="dark",
                    content="Em até 5 dias a rotina automática deve emitir o DAE para a parcela (até ~30 dias antes do vencimento). O aviso ocultará após a emissão do boleto.",
                    placement="left",
                  )
                    font-awesome-icon(
                      :icon="'file-invoice-dollar'",
                      size="lg",
                      class="color-laranja"
                    )
              el-col(:span="10")
                div(v-if="scope.row.credenciadoGEO || scope.row.credenciadoVistoria")
                  el-tooltip(
                    class="el-icon-user-solid",
                    :style="isPa ? { color: getColorIconCredenciado(scope.row) } : {}"
                    effect="dark",
                    :content="mensagemCredenciado(scope.row)",
                    placement="left",
                    )
                      span(class="el-icon-user-solid")
                      el-col(:span='10')
              el-col(:span="10", v-if="scope.row.conversaAberta")
                el-tooltip(
                  placement="right",
                  effect="dark",
                  :content="!isAp ? labelNotificacao(scope.row, scope.row.conversaAbertaDias) : labelNotificacaoAp(scope.row, scope.row.conversaAbertaDias)"
                )
                  i(v-if="scope.row.conversaAberta", :class="changeColor(scope.row)").material-icons {{getExactIcon(scope.row)}}
                  font-awesome-icon(
                    v-else
                    :icon="jsonHeaders[indexHeader].icone",
                    size="lg"
                  )
              el-col(:span="10", v-if="scope.row.desarquivado")
                el-tooltip(
                  placement="right",
                  effect="dark",
                  content="Processo desarquivado.",
                )
                  font-awesome-icon(
                    :icon="'folder-open'",
                    size="lg"
                    class="color-default"
                  )
              el-col(:span="10", v-if="isArquivamento(scope) && isPa")
                el-tooltip(
                  content="Processo aguardando análise de arquivamento"
                  effect='dark',
                  placement="top",
                )
                  font-awesome-icon(
                    :icon="'archive'",
                    size="lg"
                    class="dark"
                  )
            div(v-if="scope.row.isDadosPreenchidos")
              el-tooltip(
                placement="right",
                effect="dark",
                :content="'Dados do processo preenchidos.'"
              )
                font-awesome-icon(
                  :icon="'check'",
                  size="lg"
                  class="color-default"
                )
            div(v-if="getStatusAmbientalOrBloqueio(scope)")
              el-tooltip(
                :content="getRowTooltip(scope)"
                effect='dark',
                placement="top",
                :raw-content="true"
              )
                span
                  i(
                    :class="'fa fa-exclamation-triangle ' + getIconStatus(scope)"
                  )
            div(v-if="jsonHeaders[indexHeader].isIconeSimples")
              i(
                :class="`${(jsonHeaders[indexHeader].prefixoIcone || 'fa')} fa-${jsonHeaders[indexHeader].icone}`"
                :style="getIconStyles(jsonHeaders[indexHeader])"
              )
            div(v-if="scope.row.dataCancelamento")
              el-tooltip(
                effect="dark",
                content="Este processo foi atualizado e republicado devido a alterações recentes.",
                placement="left",
              )
                span(class="el-icon-warning color-laranja")
            div(v-if="scope.row.isNovoExtratoSentencaGerado && scope.row.setor === 'NUTIT' && filtro.caixa === 'PUBLICACAO'")
              el-tooltip(
                effect="dark",
                content="Já foi gerado um extrado de sentença com esse processo.",
                placement="left",
              )
                i.el-icon-document-checked
        //- Se não for a coluna de ações
        el-table-column(
          :label="jsonHeaders[indexHeader].titulo",
          :prop="jsonHeaders[indexHeader].propriedade",
          :sortable="getOrdenacao(jsonHeaders[indexHeader])",
          :width="setWidth(jsonHeaders[indexHeader].propriedade)",
          :formatter="jsonHeaders[indexHeader].formatter ? jsonHeaders[indexHeader].formatter : (row, col, value, index) => value ? value : '-'"
          :align="setAlign(jsonHeaders[indexHeader].propriedade)",
          v-if="!jsonHeaders[indexHeader].isPrazo  && (!jsonHeaders[indexHeader].acoes || jsonHeaders[indexHeader].acoes.length === 0) && (!jsonHeaders[indexHeader].exibir || jsonHeaders[indexHeader].exibir()) && !jsonHeaders[indexHeader].propriedade.includes('dadosCartorio')"
        )
        //- Se for coluna de data de vencimento
        el-table-column(
          :label="jsonHeaders[indexHeader].titulo",
          :prop="jsonHeaders[indexHeader].propriedade",
          :sortable="getOrdenacao(jsonHeaders[indexHeader])",
          v-if="jsonHeaders[indexHeader].isPrazo && jsonHeaders[indexHeader].exibir() && possuiGestaoPrazo",
          align="center",
          header-align="center",
          width="150"
        )
          template(slot-scope="scope")
            .col-prazo(v-if="scope.row.dataVencimento")
              .background-prazo(:style="{'background-color': getPrazoColor(scope.row.dataVencimento) }")
                span.text-prazo {{ getDataVencimentoFormatada(scope.row.dataVencimento) }}
            span(v-else) -
        //- Se for, a coluna de ações
        el-table-column(
          :label="jsonHeaders[indexHeader].titulo",
          :prop="jsonHeaders[indexHeader].propriedade",
          v-if="jsonHeaders[indexHeader].acoes.length > 0",
          align="center",
          align-header="center"
          width="150"
        )
          template(v-if="showAcao(scope.row)" slot-scope="scope")
            el-dropdown.botao-acoes(trigger="click", size="small")
              el-button(type="primary", size="mini", :id="`${scope.row.numeroProcesso}-acoes`")
                | Ações
                i.el-icon-arrow-down.el-icon--right
              el-dropdown-menu(slot="dropdown")
                div(
                  v-if="jsonHeaders[indexHeader].acoes !== null && jsonHeaders[indexHeader].acoes"
                )
                  //- ESSA VERIFICAÇÃO ACONTECE PARA MANTER A COMPATIBILIDADE DE OUTRAS TELAS,
                  //- CASO NÃO TENHA O MÉTODO SHOW DECLARADO E QUANDO POSSUIR DEVE REALIZAR A VERIFICAÇÃO
                  span(
                    v-for="(acao, indexAcao) in jsonHeaders[indexHeader].acoes",
                    v-if="!acao.show || (acao.show && acao.show(jsonData[scope.$index], acao))"
                    :id="`${scope.row.numeroProcesso}-${acao.id}-${acao.codigo}`"
                  )
                    el-dropdown-item
                      el-tooltip(
                        placement="right",
                        :disabled="acao.showToltip ? acao.showToltip(scope.row, jsonHeaders[indexHeader].acoes[indexAcao].codigo) : true",
                        :content="acao.textToltip ? acao.textToltip(scope.row) : ''"
                      )
                        div(
                          v-if="!acao.showToltip || acao.showToltip(scope.row, jsonHeaders[indexHeader].acoes[indexAcao].codigo)",
                          :id="`${scope.row.numeroProcesso}-acao-${jsonHeaders[indexHeader].acoes[indexAcao].codigo }`"
                          @click="$emit('executar', { item: jsonData[scope.$index], acao: jsonHeaders[indexHeader].acoes[indexAcao].codigo })"
                        )
                          i.fa(
                            :class="jsonHeaders[indexHeader].acoes[indexAcao].icone"
                          )
                          | &nbsp {{ jsonHeaders[indexHeader].acoes[indexAcao].nome }}
                        .disabled-content(v-else)
                          i.fa(
                            :class="jsonHeaders[indexHeader].acoes[indexAcao].icone"
                          )
                          | &nbsp {{ jsonHeaders[indexHeader].acoes[indexAcao].nome }}
        //- Tela de preencher matrícula do Cartório no REURB
        el-table-column(
          :label="jsonHeaders[indexHeader].titulo",
          :prop="jsonHeaders[indexHeader].propriedade",
          :formatter="jsonHeaders[indexHeader].formatter ? jsonHeaders[indexHeader].formatter : (row, col, value, index) => value"
          width="150",
          align="left",
          v-if="jsonHeaders[indexHeader].propriedade.includes('dadosCartorio') && jsonHeaders[indexHeader].propriedade !== 'dadosCartorio.matricula' && jsonHeaders[indexHeader].propriedade !== 'dadosCartorio.descricaoMemorial'"
        )
        el-table-column(
          :label="jsonHeaders[indexHeader].titulo",
          :prop="jsonHeaders[indexHeader].propriedade",
          v-if="jsonHeaders[indexHeader].propriedade.includes('dadosCartorio') && jsonHeaders[indexHeader].propriedade === 'dadosCartorio.descricaoMemorial'",
          width="150",
          align="left",
        )
          template(slot-scope="scope")
            span.cursor-pointer(:title="scope.row.dadosCartorio.descricaoMemorial") {{jsonHeaders[indexHeader].formatter(scope.row.dadosCartorio.descricaoMemorial)}}
        el-table-column(
          :label="jsonHeaders[indexHeader].titulo",
          :prop="jsonHeaders[indexHeader].propriedade",
          v-if="jsonHeaders[indexHeader].propriedade === 'dadosCartorio.matricula'",
          align="center",
          align-header="center"
          width="230"
          fixed
        )
          template(slot-scope="scope")
            div.flex
              el-input(
                v-model="scope.row.dadosCartorio.matricula",
                size="small",
                placeholder="Digite a matrícula"
              )
              el-tooltip(
                  effect='dark',
                  content="Clique para finalizar após preencher a matrícula",
                  placement="top"
                )
                el-button.ml-5(size="mini", @click="salvarMatricula(scope.row.dadosCartorio)")
                  i.fas.fa-save
                  span.ml-5 Finalizar

    .pagination(v-if="showPagination")
      el-pagination(
        layout="prev, pager, next",
        :total="totalElements",
        :page-size="CONFIGS.TAMANHO_PAGINACAO",
        :current-page.async="pagina + 1",
        @current-change="alterarPagina"
      )
    div(v-if="showTotalListagem").contador-total
      span Total de registros: {{ totalElements }}

    .row-buttoms
      .exportar-csv(v-if="showCsvButton")
        el-button(
          @click="$emit('exportarCsvFiltroAnalise')"
        )
          span
            i.fal.fa-file-csv
            | &nbsp Exportar CSV

      .exportar-zip-planta-memorial(v-if="showExportarZipButton")
        el-button(
          type="primary"
          @click="$emit('baixarTodosZipPlantaMemorial')"
          :loading="loadingBaixarZipPlantaMemorial"
          :disabled="disableBaixarTodosZipPlantaMemorial"
        )
          span
            i.fa.fa-file-archive
            | &nbsp; Baixar todos
        el-tooltip(placement="top" content="Marque na listagem apenas processos elegíveis (com checkbox habilitado)." :disabled="!disableBaixarSelecionadosZipPlantaMemorial")
          span(style="display: inline-block; margin-left: 12px")
            el-button(
              type="primary"
              plain
              @click="processosSelecionadosZip"
              :loading="loadingBaixarZipPlantaMemorial"
              :disabled="listaId"
            )
              span
                i.fa.fa-file-archive
                | &nbsp; Baixar selecionados

      .exportar-titulos(v-if="showButtonExportarTitulos")
        el-button(
          @click="exportarTitulos"
        )
          span
            i.fa.fa-download
            | &nbsp {{textoButtonExportarTitulo}}

      app-modal-nova(
        v-if="showModal",
        :tipo="tipoModal",
        :showModal="showModal",
        @closeModal="showModal = false",
        :width="widthModal",
        :height="heightModal",
        :padding="0"
      )
      .btn-vincular
        el-button(
          v-if="showButtonInternal && showButtonOrdemServico",
          @click="selected"
        )
          span
            i.fa.fa-users
            | &nbsp Vincular Equipe

      .btn-vincular
        el-button(
          v-if="showButtonAssinatura",
          @click="assinarTitulos",
          :disabled="disableButtonAssinaturaTitulo"
        )
          span
            i.fa.fa-pager
            | &nbsp {{textoButtonAssinatura}}

      .btn-vincular
        el-button.el-button-gov(
          v-if="showButtonAssinaturaGov",
          @click="assinarTitulosGov",
          :disabled="disableButtonAssinaturaTitulo"
        )
          span
            i.fa.fa-pencil-alt
            | &nbsp {{textoButtonAssinaturaGov}}
      .btn-vincular
        el-tooltip(
          effect='dark',
          content="Não há processos preenchidos",
          placement="top"
          v-if="showButtonEnviarProcessos"
          :disabled="!disableButtonEnviarProcessos"
        )
          div(v-if="!disableButtonEnviarProcessos")
            el-button(
              @click="enviarProcessos",
            )
              span
                i.fa.fa-check
                | &nbsp Encaminhar processo(s)
          .disabled-content(v-else)
            el-button.cursor-not-allowed
              span
                i.fa.fa-check
                | &nbsp Encaminhar processo(s)
      .btn-vincular
        el-button(
          v-if="showRegerar && showButtonRegerar"
          @click="regerarProcesso",
          :disabled="listaId"
        )
          span
            i.el-icon-refresh
            | &nbsp Regerar Selecionados
      .btn-vincular
        el-button(
          v-if="showSolicitarAcesso"
          @click="solicitarAcesso",
          :disabled="listaId"
        )
          span
            i.fa.fa-envelope
            | &nbsp Solicitar Acesso
      .btn-vincular
        el-button(
          v-if="showButtonVincularResponsavelLote",
          @click="vincularResponsavelLote"
        )
          span
            i.fa.fa-user-plus
            | &nbsp Vincular Responsável em Lote
  </template>

<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import utils from '@/utils/utils'
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
import CONFIGS from '@/constants/configs'
import AppModalNova from '@/components/AppModalNova'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'
import AppRelatorioPrazos from '@/components/AppRelatorioPrazos'
import AppDisplay from '@/components/AppDisplay'
import AppNotificacao from '@/components/mixins/AppNotificacao'

const { opcoesFiltroRapido, montarFiltroRapido, exibirCSV, showCsvButtonPermissions, perfisRegerar, isDisabled, selectItem, hasModuloRelatorioPrazo, showTotalListagem } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  components: {
    AppDividerRefreshButton,
    AppModalNova,
    AppDisplayMultiple,
    AppRelatorioPrazos,
    AppDisplay
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      CONFIGS,
      showModal: false,
      showModalTrocaResponsavel: false,
      tipoModal: '',
      showCsvButton: false,
      widthModal: '',
      heightModal: '',
      numeroProcesso: '',
      search: '',
      expandRowKeys: [],
      estado: '',
      botaoDesativado: false,
      paginatedData: [],
      allData: [],
      listaIDs: [],
      totalPaginated: 0,
      showObsOficioMA: false,
      showActionRegerar: perfisRegerar,
      isPa: process.env.ESTADO === 'pa',
      isMaranhao: process.env.ESTADO === 'ma',
      isAp: process.env.ESTADO === 'ap',
      statusAmbiental: {
        STATUS4: '100% Floresta até 2014.',
        STATUS5: 'Art. 73 - V.',
        ALERTA: 'Interseção com área de alerta.'
      },
      showTotalListagem
    }
  },

  props: {
    expandir: {
      type: Boolean
    },
    /**
      * Json com as informacões do header
      */
    jsonHeaders: {
      type: Array,
      required: true,
      default: function () {
        return [
          { id: 0, titulo: 'Ações', propriedadefalse: false, acoes: ['visualizar', 'gerenciar', 'visualizarComModal', 'trocarResponsavel'] },
          { id: 1, titulo: 'Nome', propriedadefalse: true, acoes: null },
          { id: 2, titulo: 'CPF', propriedadefalse: true, acoes: [] },
          { id: 3, titulo: 'Razão Social', propriedadefalse: true, acoes: [] },
          { id: 4, titulo: 'Situação', propriedadefalse: true, acoes: [] },
          { id: 5, titulo: 'Tipo Processo', propriedadefalse: true, acoes: [] }
        ]
      }
    },
    /**
      * Json com as informacões dos registros
      */
    jsonData: {
      type: Array,
      required: true,
      default: function () {
        return [
          { numeroProcesso: '82479823', cpfCnpjInteressado: '29138729', nomeRazaoSocialInteressado: '', situacao: '', tipoProcesso: 'Teste' },
          { nome: 'CLuis', cpfCnpjInteressado: '298139021', nomeRazaoSocialInteressado: '', situacao: '', tipoProcesso: 'Teste' },
          { nome: 'BLuis', cpfCnpjInteressado: '29138729', nomeRazaoSocialInteressado: '', situacao: '', tipoProcesso: 'Teste' }
        ]
      }
    },
    /**
      * Titulo do card
      */
    tituloCard: {
      type: String,
      required: false,
      default: ''
    },
    fontSizeTituloCard: {
      type: String,
      required: false,
      default: '32px'
    },
    /**
     * Se terá um action botão, que pode ser para cadastrar, ou qualquer outro fim
     */
    hasActionButton: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Se terá o botão de avocar processos
     */
    hasActionButtonAvocar: {
      type: Boolean,
      required: false,
      default: false
    },
    showButtonCadastraOS: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
      * Tipo do action button
      * @values primary, success, warning, danger, info, text
      */
    typeActionButton: {
      type: String,
      required: false,
      default: 'success'
    },
    /**
      * Icone que será exibido dentro do action button
      */
    iconActionButton: {
      type: String,
      required: false,
      default: 'el-icon-plus'
    },
    /**
      * Tamanho do action button
      * @values mini, small, medium, default
      */
    sizeActionButton: {
      type: String,
      required: false,
      default: 'small'
    },
    /**
      * Nome que será exibido dentro do action button
      */
    nameActionButton: {
      type: String,
      required: false,
      default: ''
    },
    /**
     * Se a lista terá um header
     */
    hasHeader: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Se a lista terá um botão de refresh
     */
    hasRefreshButton: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * O nome do header da lista
     */
    headerLabel: {
      type: String,
      required: false,
      default: 'Listagem'
    },
    /**
     * Tooltip do botão de refresh
     */
    tooltipRefreshButton: {
      type: String,
      required: false,
      default: 'Atualizar'
    },
    /**
     * Se terá uma borda abaixo do header da lista
     */
    showBorder: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Um array com os dados que serão exibidos na lista
     */
    dataForTable: {
      type: Array,
      required: false
    },
    /**
     * Total de elementos da listagem, sem paginação, ou seja, o total absoluto
     */
    totalElements: {
      type: Number,
      required: false,
      default: 0
    },
    /**
     * Página atual da listagem, sempre será atualizada ao mudar de página
     */
    pagina: {
      type: Number,
      required: true
    },
    /**
     * Ativar ou desativar o input de busca
     */
    busca: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Exibir botão vincular
     */
    showButtonOrdemServico: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * ids desabilitados no checkbox
     */
    idsDisabledCheckbox: {
      type: Array,
      required: false,
      default: () => []
    },

    showValidacaoColetiva: {
      type: Boolean,
      required: false
    },

    processosSelecionados: {
      type: Array,
      default: () => []
    },

    disableButtonAssinaturaTitulo: {
      type: Boolean,
      required: false
    },

    disableButtonEnviarProcessos: {
      type: Boolean,
      required: false
    },

    showButtonAssinatura: {
      type: Boolean,
      required: false
    },

    showButtonExportarTitulos: {
      type: Boolean,
      required: false
    },

    showButtonAssinaturaGov: {
      type: Boolean,
      required: false
    },

    textoButtonAssinatura: {
      type: String,
      default: 'Assinar Selecionados'
    },

    textoButtonExportarTitulo: {
      type: String,
      default: 'Exportar Selecionados'
    },

    textoButtonAssinaturaGov: {
      type: String,
      default: 'Assinar com Gov.br'
    },

    showButtonEnviarProcessos: {
      type: Boolean,
      required: false
    },
    /**
     * Se expansivel
     */
    hasExpansivel: {
      type: Boolean,
      required: false,
      default: false
    },
    dadosNaoEncontrado: {
      type: String,
      default: 'Não foram encontrados processos com os dados informados.'
    },
    disableButtonAvocar: {
      type: Boolean,
      required: false,
      default: false
    },
    showPagination: {
      type: Boolean,
      required: false,
      default: true
    },
    filtro: {
      required: false
    },
    hasFiltroRapido: {
      type: Boolean,
      required: false
    },
    subProcessos: {
      required: false
    },
    infoPrazos: {
      required: false
    },
    /* Mostrar botao de exportar csv */
    showExportCsv: {
      default: true,
      type: Boolean
    },
    /** Área de exportação ZIP planta/memorial (Comissão MA): dois botões que emitem {@code baixarTodosZipPlantaMemorial} e {@code baixarSelecionadosZipPlantaMemorial}. */
    showExportarZipButton: {
      type: Boolean,
      default: false
    },
    loadingBaixarZipPlantaMemorial: {
      type: Boolean,
      default: false
    },
    disableBaixarTodosZipPlantaMemorial: {
      type: Boolean,
      default: false
    },
    disableBaixarSelecionadosZipPlantaMemorial: {
      type: Boolean,
      default: false
    },
    /* Exibe o checkbox para marcar todas as linhas */
    hasMultipleCheckbox: {
      type: Boolean,
      default: false
    },
    /* Faz a paginação no próprio componente */
    paginate: {
      type: Boolean,
      default: false
    },
    showButtonRegerar: {
      type: Boolean,
      default: false
    },
    caixa: {
      type: String,
      required: false
    },
    hasRowClick: {
      type: Boolean,
      default: false
    },
    hasRefreshMounted: {
      type: Boolean,
      default: true
    },
    showSolicitarAcesso: {
      type: Boolean,
      default: false
    },
    showMensagens: {
      type: Boolean,
      default: false
    },
    showButtonVincularResponsavelLote: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  async mounted () {
    if (this.usuario && this.usuario?.perfilSelecionado.nome === 'Administrativo Municipal') {
      this.filtro.municipio.push(this.usuario.municipioPrefeitura.id)
    }
    if (this.hasRefreshMounted) {
      if (this.hasFiltroRapido) {
        this.$emit('updateListagem', { ...this.filtro, ...await montarFiltroRapido(opcoesFiltroRapido) })
      } else {
        this.$emit('updateListagem', { ...this.filtro, ...{tipoRuralPendencia: false, tipoSemRuralPendencia: false} })
      }
    }
    this.estado = process.env.ESTADO
    this.verCSV()
    this.allData = [...this.jsonData]
    this.showObsOficioMA = ((this.estado === 'ma' && !this.filtro?.caixa === 'ANALISE_COLETIVA') || (this.estado === 'pa' && this.filtro?.caixa === 'ANALISE_COLETIVA')) && this.showButtonAssinatura
    this.showCsvButton = showCsvButtonPermissions?.includes(this.filtro?.caixa)
  },

  computed: {
    showButtonInternal () {
      return _.some(this.jsonHeaders, x => x.marcado) // eslint-disable-line
    },
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),
    optionsSelect () {
      return opcoesFiltroRapido
    },
    listaId () {
      return this.listaIDs.length < 1
    },
    itemTipo () {
      return this.item.tipo === '"REURB-S'
    },
    possuiGestaoPrazo () {
      return hasModuloRelatorioPrazo
    },
    isCaixaTituloCertidao () {
      return this.caixa === 'TITULO_CERTIDAO'
    },
    isCaixaSolicitarInformacao () {
      return this.caixa === 'INFORMACAO_SOLICITADA'
    },
    caixasPermiteCheckbox () {
      return this.caixa &&
        [
          'CAIXA_AGUARDANDO_PLANTA_MEMORIAL',
          'LISTAGEM_EXPORTACAO_PLANTA_MEMORIAL'
        ].includes(this.caixa)
    }
  },

  methods: {
    ...mapActions({
      baixarCsv: 'processo/getCsvProcesso',
      getSetoresInformacoesPendentes: 'informacao/getSetoresInformacoesPendentes'
    }),

    checkboxHabilitado (row) {
      return !this.idsDisabledCheckbox.includes(row.id)
    },
    getExactIcon (tipoConversaProcesso) {
      if (!tipoConversaProcesso?.tipoConversa) return
      let ultimoSetor = this.retornaSetorAtual(tipoConversaProcesso.setorConversa)
      let tipoStatus = tipoConversaProcesso.statusConversa.split(';').reverse().join(';').split(';')
      let ultimoStatus = tipoStatus[tipoStatus.length - 1]
      let tipoConversas = tipoConversaProcesso.tipoConversa.split(';').reverse().join(';').split(';')
      let ultimaConversa = tipoConversas[tipoConversas.length - 1]
      let mudouSetorSolicitacao = tipoConversaProcesso.mudouDeSetorEmRelacaoAUltimaSolicitacao
      let mudouSetorRetificacao = tipoConversaProcesso.mudouDeSetorEmRelacaoAUltimaRetificacao
      let statusRetificacao = tipoConversaProcesso.statusUltimaRetificacao
      let setorReificacao = tipoConversaProcesso.setorUltimaRetificacao
      let cancelouRetificacao = tipoConversaProcesso.cancelouRetificacao
      let codigoStatus = tipoConversaProcesso.codigoStatus
      let retificacao = tipoConversaProcesso.retificacao
      let setorAtual = tipoConversaProcesso.setor
      let statusInterno = tipoConversaProcesso.statusConversaInterna.split(';').reverse().join(';').split(';')
      let ultimoStatusInterno = statusInterno[statusInterno.length - 1]
      let isAp = process.env.ESTADO === 'ap'

      if (!isAp) {
        if ((ultimoStatus === 'ENCERRADA' || ultimoStatus === 'RESPONDIDA') &&
            ((ultimaConversa.includes('SOLICITACAO_') || ultimaConversa === 'NOTIFICACAO_RETIFICACAO' || ultimaConversa === 'SINALIZACAO_PENDENCIA') ||
            (ultimoSetor !== tipoConversaProcesso.setor))) return ''

        if (tipoConversaProcesso.conversaAberta &&
            (ultimaConversa.includes('NOTIFICACAO_') ||
            (ultimaConversa === 'SOLICITACAO_RETIFICACAO' && ultimoStatus === 'ABERTA'))) {
          return 'sms'
        }
      } else {
        if (ultimaConversa === 'NOTIFICACAO_INTERESSADO' && ultimoStatus !== 'ENCERRADA') {
          return 'sms'
        }

        if ((ultimoStatus === 'ENCERRADA' || ultimoStatus === 'RESPONDIDA') &&
            ((ultimaConversa.includes('SOLICITACAO_') || ultimaConversa === 'NOTIFICACAO_RETIFICACAO' || ultimaConversa === 'SINALIZACAO_PENDENCIA') ||
            (ultimoSetor !== tipoConversaProcesso.setor))) return ''
      }

      if (ultimoStatus === 'CANCELADA' && ultimaConversa === 'PROTESTO') return ''

      if ((ultimaConversa.includes('RETIFICACAO') && !mudouSetorRetificacao && retificacao) ||
          (statusRetificacao === codigoStatus && setorReificacao === setorAtual && !cancelouRetificacao && ultimaConversa.includes('RETIFICACAO'))) {
        return 'refresh'
      }

      if (tipoConversaProcesso.conversaAberta && ultimaConversa.includes('SOLICITACAO_') && tipoConversaProcesso.statusConversa.includes('PENDENTE') &&
          (mudouSetorSolicitacao === false) && ultimoStatusInterno !== 'CANCELADA') {
        return 'email'
      } else if (tipoConversaProcesso.conversaAberta && ultimaConversa.includes('SOLICITACAO_') && (ultimoStatus !== 'ENCERRADA') &&
                (mudouSetorSolicitacao === false) && ultimoStatusInterno !== 'CANCELADA') {
        return 'email'
      }

      if (tipoConversaProcesso.conversaAberta && ultimaConversa === 'SINALIZACAO_PENDENCIA') {
        return 'hourglass_full'
      }

      if (tipoConversaProcesso.conversaAberta && ultimaConversa === 'PROTESTO') {
        return 'report_problem'
      }
    },
    getIconStyles (jsonHeader) {
      return {
        color: jsonHeader.corIcone || '#009f61',
        'font-size': jsonHeader.tamanhoIcone || '16px',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center'
      }
    },
    retornaSetorAtual (setores) {
      if (setores !== null) {
        let setor = setores.split(';').reverse().join(';').split(';')
        let ultimoSetor = setor[setor.length - 1]
        return ultimoSetor
      }
      return ''
    },
    showAcao (row) {
      if (row?.statusSolicitacaoAcessoCodigo === 'AGUARDANDO_AUTORIZACAO') {
        return false
      }
      return true
    },
    labelNotificacao (notificacao, conversa) {
      const tipoConversa = notificacao?.tipoConversa

      if (!tipoConversa) return ''

      let tipoConversas = notificacao.tipoConversa.split(';').reverse().join(';').split(';')
      let ultimaConversa = tipoConversas[tipoConversas.length - 1]

      if (ultimaConversa === 'PROTESTO') {
        return 'Este processo possui um protesto cadastrado.'
      }

      const conversaLabel = conversa > 1 ? 'dias' : 'dia'
      const isNotificacaoOrRetificacao = tipoConversa.includes('NOTIFICACAO_') || tipoConversa.includes('SOLICITACAO_RETIFICACAO')
      return isNotificacaoOrRetificacao ? `Notificação enviada a ${conversa} ${conversaLabel}` : `Solicitação de informação enviada a ${conversa} ${conversaLabel}`
    },

    labelNotificacaoAp (notificacao, conversa) {
      const tipoConversaProcesso = notificacao

      if (!tipoConversaProcesso?.tipoConversa) return ''

      let tipoConversas = tipoConversaProcesso.tipoConversa.split(';').reverse().join(';').split(';')
      let ultimaConversa = tipoConversas[tipoConversas.length - 1]
      let statusInterno = tipoConversaProcesso.statusConversaInterna.split(';').reverse().join(';').split(';')
      let ultimoStatusInterno = statusInterno[statusInterno.length - 1]
      let statusExterno = tipoConversaProcesso.statusConversaExterno.split(';').reverse().join(';').split(';')
      let ultimoStatusExterno = statusExterno[statusExterno.length - 1]
      let isRetificado = tipoConversaProcesso.retificacao

      const conversaLabel = conversa > 1 ? 'dias' : 'dia'

      if (ultimaConversa.includes('RETIFICACAO')) {
        if (ultimaConversa.includes('RETIFICACAO') && (isRetificado === false)) {
          return `Retificação respondida a ${conversa} ${conversaLabel}`
        } else {
          return `Retificação enviada a ${conversa} ${conversaLabel}`
        }
      }
      if (ultimaConversa.includes('NOTIFICACAO_')) {
        if (ultimoStatusExterno === 'RESPONDIDA') {
          return `Notificação respondida a ${conversa} ${conversaLabel}`
        } else {
          return `Notificação enviada a ${conversa} ${conversaLabel}`
        }
      }
      if (ultimaConversa.includes('SOLICITACAO')) {
        if (ultimoStatusInterno === 'ENCERRADA') {
          return `Solicitação respondida a ${conversa} ${conversaLabel}`
        } else {
          return `Solicitação enviada a ${conversa} ${conversaLabel}`
        }
      }
    },
    async handleCheckedFiltroRapido (newValue, option) {
      option.pendencia.find(o => o.id === newValue.id).value = !newValue.value
      const filtroFast = await montarFiltroRapido(opcoesFiltroRapido)
      this.$emit('atualizarFiltro', filtroFast)
      this.$emit('updateListagem', { ...this.filtro, ...filtroFast })
    },
    rowClicked (row) {
      if (this.expandRowKeys[0] !== row.id) {
        this.subProcessos = []
        const id = row.id
        const lastId = this.expandRowKeys[0]
        this.expandRowKeys = id === lastId ? [] : [id]

        this.$emit('buscarSubProcessos', id, 0)
      }
    },

    setWidth (propriedade) {
      return (propriedade === 'qtdOs') ? '100' : '0'
    },
    goVisualizarProcesso (processo) {
      return this.$emit('visualizarProcesso', processo)
    },
    setAlign (propriedade) {
      return (propriedade === 'qtdOs') ? 'center' : 'left'
    },

    checkAcao (processo, acao) {
      return acao.status.some(substring => processo.codigoStatus === substring)
    },

    /**
      * Aciona ao mudar de página
      *
      * @property {number} newPage a nova pagina que irá para o filtro da paginação
      */
    alterarPagina (newPage) {
      return this.$emit('changePage', newPage)
    },

    alterarPaginaSubProcesso (newPage) {
      return this.$emit('changePageSubprocesso', newPage)
    },
    /**
      * Aciona ao clicar no botão de atualizar listagem
      *
      */
    async updateListagem () {
      this.listaIDs = []
      this.$emit('updateListagem', { ...this.filtro, ...await montarFiltroRapido(opcoesFiltroRapido) })
    },

    closeModal () {
      this.showModal = false
    },
    sort (data) {
      const ordenacaoFiltro = {
        ordem: data.prop,
        tipo: ''
      }

      if (data.order === 'ascending') {
        ordenacaoFiltro.tipo = 'ASC'
      } else {
        ordenacaoFiltro.tipo = 'DESC'
      }

      this.$emit('sort', { ...ordenacaoFiltro })
    },
    selectAll (list) {
      this.$emit('selectAll', list)
    },
    selected () {
      this.$emit('selected')
    },
    regerarProcesso () {
      this.$emit('regerar', this.listaIDs)
    },
    processosSelecionadosZip () {
      this.$emit('baixarSelecionadosZipPlantaMemorial', this.listaIDs)
    },
    assinarTitulos () {
      this.$emit('assinarTitulos')
    },
    exportarTitulos () {
      this.$emit('exportarTitulos')
    },
    assinarTitulosGov () {
      this.$emit('assinarTitulosGov')
    },
    enviarProcessos () {
      this.$emit('enviarProcessos')
    },
    getOrdenacao ({ sortable }) {
      return sortable !== null && sortable !== undefined ? (sortable ? 'custom' : false) : 'custom'
    },
    getRowKeys (row) {
      return row.id
    },
    getDataVencimentoFormatada (dataVencimento) {
      return dataVencimento && new Date(dataVencimento).toLocaleDateString('pt-BR', { timeZone: 'UTC' })
    },
    getPrazoColor (data) {
      const dataAtual = new Date().toLocaleDateString('pt-BR', { timeZone: 'UTC' })
      if (utils.checkIsVencido(dataAtual, data)) {
        return '#EE4035'
      } else if (utils.checkIsAvencer(dataAtual, data)) {
        return '#FFD36B'
      } else {
        return '#009F61'
      }
    },
    salvarMatricula (dadosCartorio) {
      this.$emit('salvarMatricula', dadosCartorio)
    },
    verCSV () {
      if (this.filtro?.caixa) {
        return exibirCSV(this.filtro.caixa)
      }
      return false
    },
    changeColor (row) {
      if (row.tipoConversa) {
        let tipoStatus = row.statusConversa.split(';').reverse().join(';').split(';')
        let ultimoStatus = tipoStatus[tipoStatus.length - 1]
        let statusExterno = row.statusConversaExterno.split(';').reverse().join(';').split(';')
        let ultimoStatusExterno = statusExterno[statusExterno.length - 1]
        let statusInterno = row.statusConversaInterna.split(';').reverse().join(';').split(';')
        let ultimoStatusInterno = statusInterno[statusInterno.length - 1]
        let tipoConversas = row.tipoConversa.split(';').reverse().join(';').split(';')
        let ultimaConversa = tipoConversas[tipoConversas.length - 1]
        let isRetificado = row.retificacao
        let isAp = process.env.ESTADO === 'ap'

        if (!isAp) {
          if (ultimaConversa === 'SOLICITACAO_RETIFICACAO' || ultimaConversa === 'SOLICITAR_RETIFICACAO' || ultimaConversa === 'NOTIFICACAO_RETIFICACAO') {
            return 'aguardando-resposta'
          }
          if ((ultimaConversa.includes('NOTIFICACAO_')) && ultimoStatus !== 'ENCERRADA') {
            return 'aguardando-resposta'
          }
          if (ultimaConversa === 'NOTIFICACAO_INTERESSADO' && ultimoStatus === 'ENCERRADA') {
            return 'respondido'
          }
        }

        if (ultimaConversa === 'PROTESTO') {
          return 'aguardando-resposta'
        }
        if ((ultimaConversa === 'NOTIFICACAO_INTERESSADO' || ultimaConversa.includes('NOTIFICACAO_')) && ultimoStatus !== 'ENCERRADA') {
          return 'aguardando-resposta'
        }
        if (ultimaConversa === 'SOLICITACAO_INFORMACAO' && ultimoStatus !== 'RESPONDIDA') {
          return 'aguardando-resposta'
        }
        if (ultimoStatusExterno === 'RESPONDIDA' && ultimoStatusInterno === 'AGUARDANDO_RESPOSTA_INTERNO') {
          return 'respondido'
        }

        if (isAp) {
          if (isRetificado === true) {
            return 'aguardando-resposta'
          }
          if (ultimaConversa.includes('NOTIFICACAO_') && ultimoStatusExterno === 'AGUARDANDO_RESPOSTA_EXTERNO') {
            return 'aguardando-resposta'
          }
          if (ultimaConversa.includes('RETIFICACAO') && (isRetificado === false)) {
            return 'respondido'
          }
          if ((ultimaConversa === 'SOLICITACAO_INFORMACAO' || ultimaConversa === 'NOTIFICACAO_RETIFICACAO') && (ultimoStatus === 'ENCERRADA' || ultimoStatus === 'RESPONDIDA')) {
            return 'respondido'
          }
        }
      }
    },
    paginateArray (array) {
      return new Array(Math.ceil(array.length / CONFIGS.TAMANHO_PAGINACAO)).fill().map(_ => array.splice(0, CONFIGS.TAMANHO_PAGINACAO))
    },
    mensagemCredenciado (processo) {
      if (processo.credenciadoVistoria && processo.credenciadoGEO) {
        return 'Credenciado Geo e Vistoria'
      } else if (processo.credenciadoVistoria) {
        return 'Credenciado Vistoria'
      } else {
        return 'Credenciado Geo'
      }
    },
    getColorIconCredenciado (item) {
      if (this.filtro.caixa === 'RELATORIO_GRF_CAF_CREDENCIADOS') {
        if ((_.isBoolean(item.possuiCredenciadoGeo) && !item?.possuiCredenciadoGeo) && item?.credenciadoVistoria) {
          return '#FFD36B'
        }
        if (item?.possuiCredenciadoGeo && !item.perfil?.includes('VISTORIA_EXTERNO')) {
          return '#B22222'
        }
        return '#009d64'
      }
      if (!item?.credenciadoGEO && item?.credenciadoVistoria) {
        return '#FFD36B'
      }
      if (item?.credenciadoGEO && !item?.credenciadoVistoria) {
        return '#B22222'
      }
      return '#009d64'
    },
    showRegerar () {
      return perfisRegerar.includes(this.usuario?.perfilSelecionado.codigo)
    },
    getStatusAmbientalOrBloqueio (scope) {
      return ['STATUS4', 'STATUS5', 'ALERTA'].includes(scope.row.statusAmbiental) || scope.row.statusBloqueioDinamico === 'BLOQUEADO'
    },
    isArquivamento (scope) {
      return ['AGUARDANDO_ANALISE_ARQUIVAMENTO', 'EM_ARQUIVAMENTO'].includes(scope.row.codigoStatus)
    },
    getIconStatus (scope) {
      if (scope.row.statusBloqueioDinamico === 'BLOQUEADO' && !['STATUS4', 'STATUS5', 'ALERTA'].includes(scope.row.statusAmbiental)) {
        return 'icon-bloqued'
      } else if (scope.row.statusBloqueioDinamico !== 'BLOQUEADO' && ['STATUS4', 'STATUS5', 'ALERTA'].includes(scope.row.statusAmbiental)) {
        return 'icon-status-ambiental'
      }

      return 'icon-metade'
    },
    getRowTooltip (scope) {
      let mensagem = ''

      if (['STATUS4', 'STATUS5', 'ALERTA'].includes(scope.row.statusAmbiental)) {
        mensagem += this.statusAmbiental[scope.row.statusAmbiental]
      }

      if (scope.row.statusBloqueioDinamico === 'BLOQUEADO') {
        mensagem += ` O processo possui interseção com camada de bloqueio.`
      }

      return mensagem
    },
    desabilita (item) {
      if (this.usuario.perfilSelecionado.setor.codigo === 'EXTERNO') {
        return item.statusSolicitacaoAcesso !== null
      } else if (!item.elegivelExportacaoZipPlantaMemorialComissao && this.caixa && this.caixa === 'LISTAGEM_EXPORTACAO_PLANTA_MEMORIAL') {
        return true
      } else {
        return isDisabled(item, this.showButtonRegerar, this.usuario) || (this.caixa && this.caixa === 'TITULO_CERTIDAO' && item.codigoStatus !== 'AGUARDANDO_ENTREGA')
      }
    },
    isVariosTiposProcesso () {
      const tipos = this.jsonData?.map(data => data.tipo)
      if (tipos) {
        return !tipos.every(item => item === tipos[0])
      }
      return false
    },
    selecionaItem (item) {
      this.$emit('selectItem', item)
      selectItem(item, this.listaIDs)
      this.$emit('selecionaIds', this.listaIDs)
    },
    getTextoCredenciado (item) {
      if (!item.possuiCredenciadoGeo) {
        return 'Credenciado Vistoria'
      }
      if (item.possuiCredenciadoGeo && item.perfil?.includes('VISTORIA_EXTERNO')) {
        return 'Credenciado Geo e Vistoria'
      }
      return 'Credenciado Geo'
    },
    selecionaIds (item) {
      this.$emit('selectItem', item)
      this.selectItem(item, this.listaIDs)
      this.$emit('selecionaIds', this.listaIDs)
    },
    rowClick (item) {
      if (this.hasRowClick) {
        this.$emit('rowClick', item)
      }
    },
    getStatusBySetoresInformacoesPendentes (solicitacoes) {
      if (!solicitacoes || solicitacoes?.length === 0) {
        return null
      }
      const status = 'Aguardando informação'
      if (solicitacoes?.length === 1) {
        return `${status} do setor ${solicitacoes[0]?.setorRequerido}`
      }
      const setoresList = [...new Set(
        solicitacoes
          ?.map(s => s?.setorRequerido)
          ?.filter(s => s)
      )]
      const ultimoIndex = setoresList?.length - 1
      const setores = setoresList?.reduce((acumulate, current, index) => {
        if (index === 0) {
          return `${acumulate} ${current}`
        }
        if (index === ultimoIndex) {
          return `${acumulate} e ${current}`
        }
        return `${acumulate}, ${current}`
      }, 'dos setores')
      return `${status} ${setores}`
    },
    async virificaSetoresInformacoesPendentes () {
      const numerosProcessos = this.jsonData.map(data => data.numeroProcesso)
      const promises = numerosProcessos.map(numero => this.getSetoresInformacoesPendentes(numero))
      const results = await Promise.allSettled(promises)
      numerosProcessos.forEach((numero, indice) => {
        results[indice]['numeroProcesso'] = numero
      })
      this.jsonData.forEach(data => {
        const resultProcesso = results?.find(result => result?.numeroProcesso === data?.numeroProcesso)
        if (resultProcesso && resultProcesso?.status === 'fulfilled') {
          const novoStatus = this.getStatusBySetoresInformacoesPendentes(resultProcesso?.value)
          if (novoStatus) {
            data.status = novoStatus
          }
        }
      })
    },
    solicitarAcesso () {
      this.$emit('solicitarAcesso')
    },
    vincularResponsavelLote () {
      this.$emit('vincularResponsavelLote')
    },
    statusResultadoLogArqGIS (status) {
      let statusFlag = ['FALHA_QUADRA_INEXISTENTE', 'FALHA_LOTE_INEXISTENTE', 'FALHA_DESCONHECIDA', 'FALHA_TECNICO_NAO_PREENCHIDO', 'FALHA_REURB_NAO_PREENCHIDO']
      return statusFlag.includes(status)
    },
    statusResultadoLogArqGISNaoFinalizado (status) {
      let statusFlag = ['FALHA_LOTE_NAO_FINALIZADO', 'FALHA_ENDERECO_NAO_FINALIZADO']
      return statusFlag.includes(status)
    },
    showContratanteExternoBadge (row) {
      return row?.isContratanteExterno && row?.tipoCodigo === 'REURB_INDIVIDUAL'
    },
    showInteressadoOuConjugeOutroProcessoReurbBadge (row) {
      return row?.isInteressadoOuConjugeOutroProcesso && row.isInteressadoOuConjugeOutroProcesso
    }
  },

  watch: {
    /* Watchers para paginação frontend, quando necessário. */
    paginate: {
      handler (val) {
        if (this.paginate) {
          this.allData = [...this.jsonData]
          this.$emit('changeTotal', this.allData.length)
          this.paginatedData = this.paginateArray(this.jsonData)
        }
      }
    },
    search: {
      handler (val) {
        if (this.paginate && this.search) {
          this.allData = this.jsonData.filter((data) => !this.search || (data.nome && data.nome.toLowerCase().includes(this.search.toLowerCase())))
        } else {
          this.allData = [...this.jsonData]
        }
      }
    },
    'subProcessos.source' (oldData, newData) {
      let oldRawData = oldData.processos.filter((old) => old.responsavel)
      let newRawData = newData.processos.filter((newResponsavel) => newResponsavel.responsavel)
      for (let i = 0; i < oldRawData.length; i++) {
        if (oldRawData[i] !== newRawData[i]) {
          oldData = newRawData[i]
        }
        oldData = oldRawData[i]
      }
    },
    allData: {
      handler (val, oldVal) {
        if (this.paginate && this.allData.length) {
          this.$emit('changeTotal', this.allData.length)
          this.paginatedData = this.paginateArray(this.allData)
          this.$emit('changePage', 1)
        } else if (this.paginate && this.allData.length === 0 && val !== oldVal) {
          this.paginatedData = []
          this.$emit('changeTotal', 0)
        }
        if (this.isAp) {
          this.virificaSetoresInformacoesPendentes()
        }
      },
      deep: true
    },
    jsonData: {
      handler (val, oldVal) {
        if (this.isAp) {
          this.virificaSetoresInformacoesPendentes()
        }
      },
      deep: true
    }
    /* -------------------------------------------------------------- */
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.flex {
  display: flex;
  justify-content: space-between;
}

h1 {
  margin-top: 0px;
}
.botao-visualizar {
  color: #009d64;
  width: 24px;
  height: 24px;
  :hover {
    cursor: pointer;
  }
}

.espacamento {
  line-height: 5px;
}

.font-14px {
  font-size: 14px;
}

.margin-top {
  margin-top: 20px;
}

.color-default {
  color: #3c9170;
}

.divider {
  border: 1px solid $border-color;
  margin-bottom: 10px;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 1vh;
}

.btn-vincular {
  margin-top: 1vh;
  padding-left: 5px;

  .el-button-gov {
    background-color: #007BFF; /* Azul principal do Gov.br */
    color: #fff;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    padding: 10px 20px;
    border: none;
    transition: background-color 0.3s ease;

    display: flex;
    align-items: center;

    /* Icon spacing */
    i.fa {
      margin-right: 8px;
    }

    &:hover {
      background-color: #0056b3; /* Azul mais escuro no hover */
    }

    &:disabled {
      background-color: #3d74af; /* Cinza para estado desabilitado */
      cursor: not-allowed;
    }
  }
}

.btn-cadastrar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}

.card-container {
  margin: 20px;
  border-radius: 10px;
}
.disabled-content {
  opacity: 0.4;
  cursor: default;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0 20px 0;
  border-bottom: 1px solid $border-color;
}

.label-test {
  align-self: center;
}

.row-label {
  display: flex;
  flex-direction: row;
  margin-right: 20px;
}

.margin-left-10 {
  margin-left: 10px;
}

.margin-left-20 {
  margin-left: 20px;
}

.icon {
  font-size: 25;
  margin: 0 0 10px 5px;
}

.col-prazo {
  margin: 0px 20px 0px 20px !important;
}

.background-prazo {
  border-radius: 5px;
  width: 100%;
}

.text-prazo {
  color: white;
}

>>> .el-table th .cell {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

.botao-acoes {
  margin-left: -75px;
}

.exportar-csv {
  padding-left: 5px;
  margin-top: 1vh;
}

.exportar-zip {
  padding-left: 5px;
  margin-top: 1vh;
}

.exportar-titulos {
  padding-left: 5px;
  margin-top: 1vh;
}

.row-buttoms {
  display: flex;
  flex-direction: row-reverse;
}

.ml-5 {
  margin-left: 5px;
}

.cursor-pointer {
  cursor: context-menu;
}

.cursor-not-allowed {
  cursor: not-allowed;
}
.margin-left-100 {
  margin-left: 90%;
}
.respondido {
 color:#009d64;
}
.aguardando-resposta {
  color: #FFD36B;
}
>>> .icon-bloqued {
  color: #B22222;
}
>>> .icon-status-ambiental {
  color: #ffda0b;
}

>>> .icon-metade {
  color: #fd831e;
}

.cor-warning {
  color: #FFD36B; /* substitua pelo código da cor desejada */
}

@media (max-width: 780px) {
  .row {
    flex-direction: column;
  }
  .row-label {
    margin-bottom: 10px;
    flex-direction: column;
    margin-left: 70px;
  }

  .buttonAvocar {
    position: relative;
    right: 100px;
  }

  .btn-cadastrar {
    flex-direction: column;
  }

  >>> .el-table th .cell {
   justify-content: space-around;
  }
}

.color-laranja {
  color: orange;
  font-size: larger;
}

.color-red {
  color: red;
  font-size: larger;
}
.contador-total {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/AppListagem.vue